export enum ViewMode {
  TABLE = "table",
  MAP = "map",
}

export enum BuildingColumnKey {
  NAME = "name",
  RATE = "rate",
  WASTE = "waste",
  CONTAMINATION = "contamination",
  TENANTS = "tenants",
  STATUS = "status",
}

export type BuildingListColumn = {
  key: BuildingColumnKey;
  label: string;
  align: "left" | "right";
};

export enum SortDir {
  ASC = "asc",
  DESC = "desc",
}

export enum BuildingStatus {
  ON_TRACK = "OnTrack",
  NEEDS_ATTENTION = "NeedsAttention",
}

export type BuildingListRow = {
  terminalId: string;
  name: string;
  rate: number;
  waste: number;
  wasteUnit: string;
  contamination: number;
  tenants: number;
  status: BuildingStatus;
  lat: number | null;
  lng: number | null;
};
